import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';

import { DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL } from 'consts/copy';

import { SIMPLE_HERO_LAYOUT, type SimpleHeroProps } from '../SimpleHero';

export const SIMPLE_HERO_HYDROQUINONE_CONTENT: SimpleHeroProps = {
  header: (
    <React.Fragment>
      Hydroquinone for <br />
      fading dark spots
    </React.Fragment>
  ),
  body: 'Seeking brighter, more radiant skin? Help fade dark spots and even out your skin tone with this gold-standard hyperpigmentation treatment.',
  ctaButton: {
    buttonText: 'Get your custom formula',
    disclaimerText: DISCLAIMER_CONSULTATION_RESULTS_INGREDIENTS_CANCEL,
  },
  media: (
    <StaticImage
      src="../images/headerHydroquinoneDesktop@2x.jpg"
      alt="woman putting on custom formula"
      loading="eager"
    />
  ),
  layout: SIMPLE_HERO_LAYOUT.imageLast,
};
